<template>
  <div class="menu-container container">
    <menu-list
      :menu-data="menuData"
      :items="items"
      :sections="sections"
    ></menu-list>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import MenuList from './menu-list.vue'

  export default {
    name: 'menu-grid',
    components: {
      MenuList
    },
    props: {
      menuData: {
        type: Array,
        required: true,
        default: () => ([])
      },
      dictionary: {
        type: Object,
        required: true,
        default: () => ({})
      },
    },
    data() {
      return {
        sections: [],
        items: [],
      }
    },
    async created() {
      this.getData()
      await this.registerLang({ scope: 'pageContent', lang: this.dictionary })
    },
    methods: {
      ...mapActions('i18n', ['registerLang']),

      getData() {
        const menuItems = []
        const sections = []

        this.menuData.forEach((item) => {
          if ((item.sectionTitle || item.title)  && item.gridCards.length > 0) {
            sections.push({
              id: item.id,
              label: item.sectionTitle ?? item.title,
              columns: item.columns ? item.columns : 2
            })
          }

          if (item.gridCards) {
            item.gridCards.forEach((card) => {
              card.sectionId = item.id
              menuItems.push(card)
            })
          }
        })

        this.items = menuItems
        this.sections = sections
      }
    }
  }
</script>
